(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-set-current-location-mobile.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-set-current-location-mobile.js'); "use strict";


const {
  baseUrl
} = svs.core.data;
const trimRoute = route => route.replace(/\/$/, '');
const {
  config = {}
} = svs.sportsbook.data;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_setCurrentLocationMobile = () => location => {
  const urlFragments = svs.sportsbook.sbtech_api_impl.utils.parseUrlToFragments(location);
  const title = svs.sportsbook.sbtech_api_impl.utils.buildTitle(urlFragments);
  document.title = "".concat(config.moduleTitle || '').concat(title ? " | ".concat(title) : '');
  history.replaceState(null, null, trimRoute(baseUrl + location));
};
 })(window);